import React from 'react';
import ButtonGroup from 'ub/components/properties-panel/button-group';

const ParagraphStyleButtonGroup = ({ listStyle, changeHandler, inEditMode }) => {
  const _triggerChangeForListStyle = (newListStyle) => {
    changeHandler({
      type: 'listStyleChange',
      value: newListStyle
    });
  };

  const _triggerChangeForIndentation = (indent) => {
    changeHandler({
      type: 'indentationChange',
      value: indent
    });
  };

  const _triggerChangeForHR = (newHR) => {
    changeHandler({
      type: 'horizontalLineChange',
      value: newHR
    });
  };

  const paragraphStyleOptions = [
    {
      iconClass: "svg-ico-unordered-list large",
      clickHandler: () => _triggerChangeForListStyle('UL'),
      isActive: listStyle === 'ul',
      title: 'Bulleted List'
    },
    {
      iconClass: "svg-ico-ordered-list large",
      clickHandler: () => _triggerChangeForListStyle('OL'),
      isActive: listStyle === 'ol',
      title: 'Numbered List'
    },
    {
      iconClass: "svg-ico-unindent large",
      clickHandler: () => _triggerChangeForIndentation('outdent'),
      isActive: false,
      title: 'Decrease Indent'
    },
    {
      iconClass: "svg-ico-indent large",
      clickHandler: () => _triggerChangeForIndentation('indent'),
      isActive: false,
      title: 'Increase Indent'
    },
  ];

  if (inEditMode) {
    paragraphStyleOptions.push({
      iconClass: "svg-ico-horizontal-line large",
      clickHandler: () => _triggerChangeForHR(),
      isActive: false,
      title: 'Horizontal Line'
    });
  }

  return <ButtonGroup options={paragraphStyleOptions} />;
};

ParagraphStyleButtonGroup.propTypes = {
  listStyle: React.PropTypes.string,
  changeHandler: React.PropTypes.func.isRequired,
  inEditMode: React.PropTypes.bool.isRequired,
};

export default ParagraphStyleButtonGroup;



// WEBPACK FOOTER //
// ./src/ui/inline-text/style-tab-content-components/paragraph-style-button-group.jsx